import axios from "axios";
import settings from "utils/settings";

const apiUrl = `${settings.apiUrl}api/`;

const controllerUrl = `${apiUrl}notification-template`;

export const requestNoPagination = (filters) =>
    axios.post(`${controllerUrl}/list`, {
      criteria: filters
    });

export const requestCreateTemplate = (data) => axios.post(`${controllerUrl}`, data);

export const requestUpdateTemplate = (id, data) => axios.put(`${controllerUrl}/${id}`, data);

export const requestDeleteTemplate = (id) => axios.delete(`${controllerUrl}/${id}`);



// WEBPACK FOOTER //
// ./src/actions/notificationTemplates/requests.js